import { connect } from 'react-redux'
import { FirefoxButton } from '../../../Components/FirefoxButton'

const mapStateToProps = (state, params) => {
  return {
    text: state.localization.dictionary.login.contFirefox
  }
}

const FirefoxButtonConnected = connect(
  mapStateToProps
)(FirefoxButton)

export {
  FirefoxButtonConnected as FirefoxButton
}
